import { useTranslation } from 'react-i18next';
import type { IAlert } from '@interfaces/ISubcontractorPortal';
import { WarningTriangleIcon } from '@utils/icons';
import { formatRelative } from '../subcontractors.format';
import styles from './IssuesAlerts.module.css';

export function IssuesAlerts({ alerts, tz }: { alerts: IAlert[]; tz: string }) {
  const { t } = useTranslation();

  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <h3 className={styles.title}>{t('subcontractors.alerts.title')}</h3>
        <span className={styles.count}>
          {t('subcontractors.alerts.count', { count: alerts.length })}
        </span>
      </header>
      {alerts.length === 0 ? (
        <p className={styles.empty}>{t('subcontractors.alerts.empty')}</p>
      ) : (
        <ul className={styles.list}>
          {alerts.map((a) => (
            <li key={a.id} className={styles.alert} data-severity={a.severity}>
              <span className={styles.icon} aria-hidden="true">
                <WarningTriangleIcon size={16} />
              </span>
              <div className={styles.body}>
                <div className={styles.alertHead}>
                  <span className={styles.alertTitle}>{a.title}</span>
                  <span className={styles.timestamp}>{formatRelative(a.raisedAt, tz)}</span>
                </div>
                <p className={styles.alertBody}>{a.body}</p>
                {a.actionLabel ? (
                  <button type="button" className={styles.action}>
                    {a.actionLabel}
                  </button>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
